import { Tooltip } from 'antd'

function B2becTooltip(props) {
  const { title = '', content = '' } = props
  return (
    <Tooltip title={title} {...props}>
      <span>{content}</span>
    </Tooltip>
  )
}

export default B2becTooltip
